import { CallAPI } from "../../apiManager/ApiCall";
import {
  pathologyDiseasesURL,
  pathologyOverlaysURL,
  pathologyOverlayGenerateURL,
} from "../../apiManager/APIConfig";

export const listPathologyDiseasesCall = async (slideId) => {
  const params = new URLSearchParams({ slide_id: slideId });
  const url = `${pathologyDiseasesURL}?${params.toString()}`;
  return CallAPI({ url, method: "GET" });
};

export const createPathologyDiseaseCall = async (body) =>
  CallAPI({ url: pathologyDiseasesURL, method: "POST", body });

export const updatePathologyDiseaseCall = async (id, body) => {
  const url = `${pathologyDiseasesURL}/${id}`;
  return CallAPI({ url, method: "PUT", body });
};

export const deletePathologyDiseaseCall = async (id) => {
  const url = `${pathologyDiseasesURL}/${id}`;
  return CallAPI({ url, method: "DELETE" });
};

export const listPathologyOverlaysCall = async ({ slideId, diseaseId }) => {
  const params = new URLSearchParams({ slide_id: slideId });
  if (diseaseId) params.set("disease_id", diseaseId);
  const url = `${pathologyOverlaysURL}?${params.toString()}`;
  return CallAPI({ url, method: "GET" });
};

export const getPathologyOverlayCall = async (id) => {
  const url = `${pathologyOverlaysURL}/${id}`;
  return CallAPI({ url, method: "GET" });
};

export const generatePathologyOverlayCall = async (body) =>
  CallAPI({
    url: pathologyOverlayGenerateURL,
    method: "POST",
    body,
  });

export const acceptPathologyOverlayCall = async (id, body = {}) => {
  const url = `${pathologyOverlaysURL}/${id}/accept`;
  return CallAPI({ url, method: "POST", body });
};

export const regeneratePathologyOverlayCall = async (id, body = {}) => {
  const url = `${pathologyOverlaysURL}/${id}/regenerate`;
  return CallAPI({ url, method: "POST", body });
};

export const deletePathologyOverlayCall = async (id) => {
  const url = `${pathologyOverlaysURL}/${id}`;
  return CallAPI({ url, method: "DELETE" });
};
